import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfigService } from "src/app/shared/services/config.service";
import { Router } from "@angular/router";
import { UserService } from "../../../shared/user.service";
import { AuditComponent } from "../audit/audit.component";
import { UserActivityComponent } from "../user-activity/user-activity.component";
import { ManageFolderStructureComponent } from "../manage-folder-structure/manage-folder-structure.component";

@Component({
    selector: 'app-administration-page',
    templateUrl: './administration-page.component.html',
    styleUrls: ['./administration-page.component.css']
})
export class AdministrationComponent implements OnInit {
    public audit = false;
    public userActivity = false;
    public manageFolderStructure = false;
    @ViewChild('auditPage') auditPage: AuditComponent;
    @ViewChild('userActivityPage') userActivityPage: UserActivityComponent;
    @ViewChild('manageFolderStructurePage') manageFolderStructurePage: ManageFolderStructureComponent;
    constructor(public config: ConfigService, private router: Router, public userService: UserService) {

    }
    ngOnInit() {
        this.userActivity = true;
        this.config.audit = false;
        this.manageFolderStructure = false;
        this.config.userActivity = true;
        this.config.homeActive = false;
        this.config.searchActive = false;
        this.config.personalBrowserActive = false;
        this.config.uploadAssetsActive = false;
        let url = this.router.url;
        // if (url.indexOf('audit') > 0) {
        //     this.config.audit = true;
        //   } else  if (url.indexOf('user-activity') > 0) {
        //     this.config.userActivity = true;
        //   } 
    }
    /**
     *Method will be called on clicking of audit tab
     */
    navigateToAudit() {
        this.config.userActivity = false;
        this.config.audit = true;
        this.audit = true;
        this.userActivity = false;
        this.manageFolderStructure = false;
        this.config.manageFolderStructure = false;
    }
    
     /**
     *Method will be called on clicking of userActivity tab
     */
    navigateToUser() {
        this.config.userActivity = true;
        this.config.audit = false;
        this.userActivity = true;
        this.audit = false;
        this.manageFolderStructure = false;
        this.config.manageFolderStructure = false;
    }
    navigateToManageFolderStructure() {
        this.config.userActivity = false;
        this.config.audit = false;
        this.userActivity = false;
        this.audit = false;
        this.manageFolderStructure = true;
        this.config.manageFolderStructure = true;
    }
}
